import { render, staticRenderFns } from "./purchaserTable.vue?vue&type=template&id=f272940a&scoped=true"
import script from "./purchaserTable.vue?vue&type=script&lang=js"
export * from "./purchaserTable.vue?vue&type=script&lang=js"
import style0 from "./purchaserTable.vue?vue&type=style&index=0&id=f272940a&lang=less&scoped=true"
import style1 from "./purchaserTable.vue?vue&type=style&index=1&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f272940a",
  null
  
)

export default component.exports